import {BrowserRouter, Routes, Route} from "react-router-dom";
import React from "react";

import Main from "./pages/Main";
import NewsletterYearRoute from "./pages/newsletter/NewsletterYearRoute";
import AdminApp from "./admin/AdminApp";
import BlogPosts from "./pages/BlogPosts";
import BlogPost from "./pages/BlogPost";
import Error from "./pages/Error";
import Impressum from "./pages/Impressum";
import Dsgvo from "./pages/Dsgvo";
import Newsletter from "./pages/Newsletter";


function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route index element={
            <Main/>
          }/>
          <Route path="/*" element={
            <Error/>
          }/>
          <Route path="/dsgvo" element={
            <Dsgvo/>
          }/>
          <Route path="/impressum" element={
            <Impressum/>
          }/>
          <Route path="/blogs" element={
            <BlogPosts/>
          }/>
          <Route path="/blogs/:id" element={
            <BlogPost/>
          }/>
          <Route path="/admin/*" element={
            <AdminApp/>
          }/>
          <Route path="/newsletter/*" element={<NewsletterYearRoute/>} />

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
